import { ofType } from "redux-observable";
import { ignoreElements, tap } from "rxjs/operators";
import { IdEventSoundCore } from "../../../utils/sound/IdEventSoundCore";
import { utilSound } from "../../../utils/sound/utilSound";
import { TypeActionTrade } from "../../trade-component/actionTrade";
export var epicSoundsTradeSell = function (action$) {
    return action$.pipe(ofType(TypeActionTrade.Sell), tap(function () { return utilSound.event(IdEventSoundCore.ItemSell); }), ignoreElements());
};



//////////////////
// WEBPACK FOOTER
// ./src/features/sound/epics/epicSoundsTradeSell.ts
// module id = 2413
// module chunks = 3